// A face's quality warnings as small outline badges with their short names: the Unassigned faces
// tiles and the overlay's face cards say them the same way.
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { qualityFlagName } from './format'

export function QualityFlagBadges({ flags }: { flags: readonly string[] }) {
  const { t } = useTranslation()
  return flags.map(flag => (
    <Badge key={flag} variant="outline" className="px-1 py-0 text-2xs font-normal">
      {qualityFlagName(flag, t)}
    </Badge>
  ))
}
